(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["mc-global-css"]) return;
  try {
    
(function(){
  function widont(el){
    var last=el.lastChild;
    if(!last||last.nodeType!==3)return;
    var t=last.nodeValue.replace(/\s+$/,'');
    var m=t.match(/^([\s\S]*\S)\s+(\S+)$/);
    if(m)last.nodeValue=m[1]+' '+m[2];
  }
  function go(){
    var heroImage=document.querySelector('[id$="__hero"] img');if(heroImage&&!heroImage.alt){heroImage.alt='Milan candle in a composed interior';}
    var houseEmail=document.querySelector('[id$="__join_the_house"] .fs__email');if(houseEmail){houseEmail.setAttribute('aria-label','Email address');}
    document.querySelectorAll('a[href$="/cart"]').forEach(function(a){var sr=a.querySelector('.sr-only');if(sr){var rest=(a.textContent||'').replace(sr.textContent,'');if(/cart/i.test(rest)){sr.remove();}}});
    var sels='p,[class*="__text"],[class*="__sub"],[class*="__intro"],[class*="__desc"],[class*="__excerpt"],.mcl__title,.hj-card__title,.mch__h1';
    document.querySelectorAll(sels).forEach(widont);
  }
  if(document.readyState!=='loading'){go();}else{document.addEventListener('DOMContentLoaded',go);}
})();

  } catch(e) { console.error(e); }
})();
})();
